import { jsx as o } from "react/jsx-runtime";
import { useRegisterFormRootContainer as e } from "../../common/hooks/useFormElementRegistry.js";
import { Dialog as r } from "./Dialog/Dialog.js";
const i = ({ children: i2, onDialogClose: t, isModalOpen: n = true, width: l, height: s, disableScroll: a = false, hideBackdrop: d = false }) => {
  const { ref: h } = e();
  return o(r, { onClose: t, open: n, hideBackdrop: d, sx: { ".MuiPaper-root": { maxWidth: l || "896px", width: "100%", height: s, borderRadius: "8px", overflowY: a ? "initial" : "auto" } }, noContent: true, ref: h, children: i2 });
};
export {
  i as FormDialog
};
//# sourceMappingURL=FormDialog.js.map
